import {Component, OnInit, HostListener, ViewChild, AfterViewInit, OnDestroy} from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

import {Calendar, DateRangeInput, EventClickArg, EventDropArg, DatesSetArg, EventContentArg} from '@fullcalendar/core';
import {TimeCardService} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import {VacationEventsQuery} from './data/vacation-events.query';
import {VacationEventsStore} from './data/vacation-events.store';
import {VacationDaysService} from './data/vacation-days.service';
import {LoginService, takeUntilDestroyed} from 'projects/core/src/public-api';
import {DeviceDetectorService} from 'ngx-device-detector';
import moment from 'moment';
import {FcMouseEvent} from '../../../full-calendar/data/fc-mouse-event';
import {VacationDayDialogComponent} from './vacation-day-dialog/vacation-day-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {TimeCard} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card';
import {ConfirmationService} from 'primeng/api';
import {FcRenderEvent} from '../../../full-calendar/data/fc-render-event';
import jQuery from 'jquery';
import {transaction} from '@datorama/akita';
import {filter} from 'rxjs/operators';
import {Subject, timer} from 'rxjs';

import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {OverlayPanel} from 'primeng/overlaypanel';
import {takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {
  VacationPdfGenerateDialogComponent
} from 'projects/desktop/src/app/modules/timesheets/view/vacation-calendar/vacation-pdf-generate-dialog/vacation-pdf-generate-dialog.component';
import {VacationDay} from 'projects/desktop/src/app/modules/timesheets/view/vacation-calendar/data/vacation-day';
import {AppStateQuery} from '../../../../data/app-state.query';
import {User} from '../../../../../../../core/src/lib/login/data/user';


@Component({
  selector: 'app-vacation-calendar',
  templateUrl: './vacation-calendar.component.html',
  styleUrls: ['./vacation-calendar.component.scss'],
  providers: [
    VacationEventsStore,
    VacationDaysService,
    VacationEventsQuery,
    DeviceDetectorService,
    ConfirmationService
  ]
})
@RxJSUnsubscribe
export class VacationCalendarComponent implements OnInit, AfterViewInit, OnDestroy, RxJSUnsubscribable {

  @ViewChild('vfc', {static: true})
  vfc: any;

  @ViewChild('holidayOp', {static: true})
  holidayOp: OverlayPanel

  options: any;

  monthToShow = new Date();

  loadingEvents = true;
  loadingCalendar: boolean;

  events$ = this.vacationEventsQuery.selectAll()

  isMobile = false;
  isTablet = false;
  isDesktop = false;
  currentUser: User;

  rejectReason = '';

  choosenDaysMap = new Map();

  approveLoading: boolean;
  rejectLoading: boolean;

  startDate: Date;
  endDate: Date;

  tempTarget: any;

  holidayStr: string;

  constructor(
    protected dialog: MatDialog,
    protected projectActivityService: ProjectActivityService,
    protected vacationDaysService: VacationDaysService,
    protected vacationEventsQuery: VacationEventsQuery,
    protected vacationEventsStore: VacationEventsStore,
    protected confirmationService: ConfirmationService,
    protected timeCardService: TimeCardService,
    private appStateQuery: AppStateQuery,
    protected deviceDetectorService: DeviceDetectorService
  ) {
    this.isMobile = this.deviceDetectorService.isMobile();
    this.isTablet = this.deviceDetectorService.isTablet();
    this.isDesktop = this.deviceDetectorService.isDesktop();
  }


  get calendar(): Calendar {
    return this.vfc.calendar as Calendar
  }

  ngOnInit(): void {
    this.appStateQuery.currentUser$.subscribe(currentUser => {
      this.currentUser = currentUser;
    });
    this.vacationEventsQuery
      .dareRange$
      .pipe(
        filter(dateRange => !!(dateRange && dateRange.start && dateRange.end)),
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(dateRange => {
        this.vacationDaysService.loadEventsForCalendar(dateRange)
      })


    this.events$
      .subscribe(events => {
        if (this.options) {
          this.options.events = events;
        }
      })

    this.vacationDaysService.loadingEvents$
      .pipe(
        takeUntil(this.getUnsubFromAllSubs())
      )
      .subscribe(status => {
        this.loadingEvents = status
        this.loadingCalendar = false;
      })


    this.options = {
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      initialDate: this.monthToShow,
      // timeZone: 'America/Vancouver',
      // businessHours: {
      // 	// days of week. an array of zero-based day of week integers (0=Sunday)
      // 	daysOfWeek: [1, 2, 3, 4, 5], // Monday - Thursday

      // 	startTime: '10:00', // a start time (10am in this example)
      // 	endTime: '18:00', // an end time (6pm in this example)
      // },
      headerToolbar: {
        left: '',
        center: 'prev,title,next',
        right: ''
      },
      height: 840,
      editable: true,
      displayEventTime: false,
      // weekends: false,
      eventClick: (info: EventClickArg) => {
        this.onEventClick(info)
      },
      eventDrop: (info: EventDropArg) => {
        this.onEventDrop(info)
      },
      datesSet: (info: DatesSetArg) => {
        this.onDateChange(info);
      },
      eventContent: (info: EventContentArg) => {
        const result = this.eventRenderTemplate(info);
        return { domNodes: [this.createElementFromHTML(result.html)] };
      },
      eventDidMount: (info: EventContentArg) => {
        this.eventDidMount(info)
      }
    }
  }

  eventRenderTemplate(eventInfo: EventContentArg) {
    const vacationActivity = this.vacationDaysService.eventsMap.get(eventInfo.event.id)

    let htmlSpanToShow = '';

    if (vacationActivity.type === 'VACATION') {
      htmlSpanToShow = 'VAC'
    }

    if (vacationActivity.type === 'UNPAID_VACATION') {
      htmlSpanToShow = 'UPVAC'
    }

    if (vacationActivity.type === 'SICK_HOURS') {
      htmlSpanToShow = 'SIK'
    }

    return {
      html: `
  		<div class="fc-content">
  			<div class="event-box">
  				<div class="event-title">
  					<span class="event-title-span">${eventInfo.event.title}<span>
  				</div>
  				<div class="delivery-instruction-mark">
            <i class="pi pi-exclamation-triangle" style="font-size: 100%"></i>
  				</div>
  				<div class="event-shortcode">
  					<span class="activity-short-code">${htmlSpanToShow}</span>
  				</div>
  			</div>
  		</div>
  	`
    }

  }

  fillHolidays() {
    const startDate = moment(this.startDate).format('YYYY-MM-DD');
    const endDate = moment(this.endDate).format('YYYY-MM-DD');
    const map = new Map();

    this.projectActivityService.getHolidays(startDate, endDate).subscribe(days => {
      days.forEach(day => {
        const date = moment(day.date).format('LL')
        map.set(date + '', day.name)
      })


      const headDays = (this.vfc.element.nativeElement as HTMLElement).getElementsByClassName('fc-daygrid-day-top');

      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < headDays.length; i++) {
        const aBlock = headDays[i].children[0]

        if (aBlock.attributes[2].name === 'aria-label') {
          if (aBlock.attributes[2].value && map.has(aBlock.attributes[2].value)) {
            const holiday = map.get(aBlock.attributes[2].value);

            const holidaySpan = document.createElement('a')
            holidaySpan.innerHTML = 'H';

            holidaySpan.classList.add('holiday-mark')

            const holidayEl = jQuery(holidaySpan)

            // tslint:disable-next-line: deprecation
            holidayEl.hover(jQEvent => {
              this.holidayStr = holiday
              this.holidayOp.show(null, jQEvent.target)

            }, jQEvent => {
              this.holidayOp.hide()
            })

            if (headDays[i].children.length === 1) {
              headDays[i].appendChild(holidaySpan)
            }
          }
        }
      }

    })

  }

  eventDidMount(eventInfo) {
    const eventEl = jQuery(eventInfo.el)

    // if(eventInfo.event.extendedProps.rejected) {
    //   return
    // }

    // tslint:disable-next-line: deprecation
    eventEl.dblclick(jQEvent => {
      this.openVacDay(eventInfo)
    })

    if (this.isTablet) {
      // tslint:disable-next-line: deprecation
      eventEl.click(jQEvent => {
        this.openVacInTablet(eventInfo)
      })
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    this.updateCalendarHeight();
  }

  ngAfterViewInit() {
    this.updateCalendarHeight();
  }

  openVacInTablet(eventInfo: FcRenderEvent) {
    const classArr = [];

    eventInfo.el.classList.forEach(classss => {
      classArr.push(classss)
    })
    if (classArr.includes('temp-clicked-day')) {
      this.openVacDay(eventInfo)


      if (this.tempTarget && this.tempTarget.classList.contains('temp-clicked-day')) {
        this.tempTarget.classList.remove('temp-clicked-day')
      }
    }

  }

  scrollToToday() {
    const scrollElems: HTMLElement[] = this.vfc.element.nativeElement.getElementsByClassName('fc-scroller');
    const scrollEl: HTMLElement = scrollElems[0]
    const todayElems = scrollEl.getElementsByClassName('fc-day-today')
    // todayElems[0].scrollIntoView()
    if (todayElems.length >= 2) {

      setTimeout(() => {
        todayElems[1].scrollIntoView();
      }, 1)

    }
  }

  updateCalendarHeight() {
    if (this.calendar) {
      this.calendar.setOption('height', this.vfc.element.nativeElement.clientHeight - 60)
    } else {
      let retries = 0;

      timer(250).subscribe(emit => {
        if (++retries <= 3) {
          this.updateCalendarHeight();
        }
      })
    }
  }

  onDateChange(info: DatesSetArg) {
    this.startDate = info.view.activeStart;
    this.endDate = info.view.activeEnd;
    this.vacationEventsStore.updateDateRange(info.view.activeStart, info.view.activeEnd)

    this.scrollToToday()

    this.fillHolidays();
    this.choosenDaysMap.clear();
  }

  onEventDrop(info: EventDropArg) {
    this.timeCardService.updateTimeCard({
      id: +info.event.id,
      startTime: moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss'),
      finishTime: moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss'),
      notes: 'Update Vacation Day'
    }).subscribe(result => {
      this.vacationEventsStore.update(+info.event.id, {
        start: moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss'),
        finishTime: moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss')
      })
    })
  }

  @transaction()
  onEventClick(info: EventClickArg) {
    if (this.tempTarget) {
      if (this.tempTarget.classList.contains('temp-clicked-day')) {
        this.tempTarget.classList.remove('temp-clicked-day')
      }
    }

    let target = info.jsEvent.target as HTMLElement // Getting element user clicked on

    if (target.localName === 'span') {
      target = target.parentElement
    }
    target = target.parentElement

    this.tempTarget = target

    if (this.isTablet) {
      if (!this.tempTarget.classList.contains('temp-clicked-day')) {
        this.tempTarget.classList.add('temp-clicked-day')
      } else {
        this.tempTarget.classList.remove('temp-clicked-day')
      }
    }

    if (!info.event.extendedProps.approved && !info.event.extendedProps.rejected) {
      if (!this.tempTarget.classList.contains('clicked-day')) {
        this.tempTarget.classList.add('clicked-day')
        this.choosenDaysMap.set(info.event.id, info.event.extendedProps)
      } else {
        this.tempTarget.classList.remove('clicked-day')
        this.choosenDaysMap.delete(info.event.id)
      }
    }

  }

  openVacDay(info: FcMouseEvent) {
    let buttonLabel
    if (info.event.extendedProps.approved) {
      buttonLabel = 'Unapprove';
    } else {
      buttonLabel = 'Approve';
    }

    const dialogRef = this.dialog.open(VacationDayDialogComponent, {
      data: {
        timeCard: {
          id: +info.event.id,
          startTime: moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss'),
          finishTime: moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss'),
          approved: info.event.extendedProps.approved,
          rejected: info.event.extendedProps.rejected,
          rejectReason: info.event.extendedProps.rejectReason,
          user: {id: info.event.extendedProps.userId},
          type: info.event.extendedProps.type
        } as VacationDay,
        buttonLabel
      },
      disableClose: false,
      panelClass: 'vacation-calendar-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.vacationDaysService.loadEventsForCalendar({
        start: this.startDate,
        end: this.endDate
      });
      this.choosenDaysMap.clear();
      this.timeCardService.vacationCounterSubj.next();
    });
  }

  approveSelectedDays() {
    const vacDays = [];
    this.choosenDaysMap.forEach((day, key) => {
      vacDays.push(key)
    })


    this.confirmationService.confirm({
      header: 'Approve Vacation?',
      message: `Approve choosen vacation days?`,
      accept: () => {
        this.approveLoading = true;

        this.vacationDaysService.toggleVacationDay(vacDays.join(',')).subscribe(emit => {
          this.vacationDaysService.loadEventsForCalendar({
            start: this.startDate,
            end: this.endDate
          });
          this.choosenDaysMap.clear();

          this.approveLoading = false;
          this.timeCardService.vacationCounterSubj.next()
        }, error => {
          this.approveLoading = false;
          this.timeCardService.vacationCounterSubj.next()
        })
      }
    });

  }

  rejectSelectedDays() {
    const vacDays = [];
    this.choosenDaysMap.forEach((day, key) => {
      vacDays.push(parseInt(key))
    })

    const elem = document.getElementsByClassName('p-dialog-content');
    const textArea = '<div class="reject-area-block">' +
      '<textarea matInput [required]="true" class="text-area-reject" placeholder="Reject Reason"></textarea>' +
      '</div>';

    this.confirmationService.confirm({
      header: 'Reject Vacation?',
      message: `Reject choosen vacation days?`,
      accept: () => {
        const textArea = document.getElementsByClassName('text-area-reject');
        const reason = (textArea[0] as HTMLTextAreaElement).value

        this.rejectLoading = true;

        this.vacationDaysService.rejectVacationDay(vacDays, reason).subscribe(emit => {
          this.vacationDaysService.loadEventsForCalendar({
            start: this.startDate,
            end: this.endDate
          });
          this.choosenDaysMap.clear();

          this.rejectLoading = false;
          this.timeCardService.vacationCounterSubj.next()
        }, error => {
          this.rejectLoading = false;
          this.timeCardService.vacationCounterSubj.next()
        })
      }
    });

    timer(1).subscribe(emit => {
      (elem[0] as HTMLElement).insertAdjacentHTML('afterend', textArea)
      const textAreaHTML = document.getElementsByClassName('text-area-reject')[0] as HTMLTextAreaElement;
      textAreaHTML.focus()
    })
  }

  requestVactions() {
    const dialogRef = this.dialog.open(VacationDayDialogComponent, {
      data: {
        buttonLabel: 'Request',
        type: 'VACATION'
      },
      disableClose: false,
      panelClass: 'vacation-calendar-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Success!') {
        const dateRange: DateRangeInput = {
          start: this.startDate,
          end: this.endDate
        }

        this.timeCardService.vacationCounterSubj.next()
        this.vacationDaysService.loadEventsForCalendar(dateRange)
      }
    });
  }

  generatePdf() {
    const dialogRef = this.dialog.open(VacationPdfGenerateDialogComponent, {
      disableClose: false,
      panelClass: 'vacation-pdf-generate-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ngOnDestroy() {
  }

  createElementFromHTML(htmlString: string): HTMLElement {
    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild as HTMLElement;
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }
}
